import React from 'react';
import './Footer.css';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-cta">
            <h2 className="footer-title">
              Ready To Start Your <span className="highlight">Digital Journey?</span>
            </h2>
            <p className="footer-subtitle">
              Join hundreds of successful businesses who trust Nodex Global LLC to drive their digital growth.
            </p>
          </div>
          <div className="footer-action">
            <a href="#contact" className="btn btn-primary">Get a quote</a>
          </div>
        </div>

        <div className="footer-grid">
          <div className="footer-widget">
            <div className="logo footer-logo">
              <div className="logo-icon">NG</div>
              <span className="logo-text">Nodex Global</span>
            </div>
            <p className="footer-desc">
              A premium digital marketing agency dedicated to driving revenue and growth for modern businesses.
            </p>
            <div className="social-links">
              <a href="#" aria-label="Facebook"><FaFacebookF /></a>
              <a href="#" aria-label="Twitter"><FaTwitter /></a>
              <a href="#" aria-label="Instagram"><FaInstagram /></a>
              <a href="#" aria-label="LinkedIn"><FaLinkedinIn /></a>
            </div>
          </div>

          <div className="footer-widget">
            <h3>Services</h3>
            <ul>
              <li><a href="#">SEO Optimization</a></li>
              <li><a href="#">PPC Advertising</a></li>
              <li><a href="#">Social Media Marketing</a></li>
              <li><a href="#">Web Development</a></li>
              <li><a href="#">Content Strategy</a></li>
            </ul>
          </div>

          <div className="footer-widget">
            <h3>Company</h3>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#process">Our Process</a></li>
              <li><a href="#reviews">Testimonials</a></li>
              <li><a href="#">Careers</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-widget">
            <h3>Legal</h3>
            <ul>
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Terms of Service</a></li>
              <li><a href="#">Cookie Policy</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Nodex Global LLC (nodexgloballlc.com). All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
